'use client';

import { PolicyPage } from 'components/organisms/PolicyPage';

const DisclaimersPage = () => <PolicyPage id="5fdcd5c7-7473-4c70-831d-c22c6262548d" />;

export default DisclaimersPage;
